import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '__services';
import { isEmpty } from 'lodash';
import { Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { DashboardConstants } from '~/app/containers/dashboard/dashboard.const';
import { Constants } from '~/app/core/configs/constants';
import { Status } from '~/app/core/configs/status';
import { Steps } from '~/app/core/models/types';
import { FlowService } from '~/app/core/services/flow.service';
import { SwalService } from '~/app/core/services/swal.service';
@Injectable({
  providedIn: 'root',
})
export class FlowStepsService {
  steps: Steps[];
  stepOneForm: FormGroup;
  isFlowChanged: boolean;
  flowId: any;
  stepId: number;
  selectedIndex = 0;
  url: string;
  stepsState: any[];
  delayShowPanel: boolean;
  viewMode: boolean;
  helpFlowPersonaIdValidate: number | null = null;
  helpFlowCompanyValidate: any = null;

  constructor(
    public flowService: FlowService,
    private router: Router,
    private translateService: TranslateService,
    private activatedRoute: ActivatedRoute
  ) {}

  get viewOnly(): boolean {
    return this.viewMode;
  }

  delayPanel(): void {
    this.delayShowPanel = false;
    setTimeout(() => {
      this.delayShowPanel = true;
    }, 800);
  }

  // updateStepState(stepsState: any[]): void {
  //   if (Array.isArray(stepsState)) {
  //     stepsState.forEach((item, index) => {
  //       this.steps[index].isComplete = item;
  //     });
  //   }
  // }

  getData(id, params): Observable<any> {
    return this.flowService.getFlowById(this.getFlowId(), params, this.url).pipe(
      tap((res) => {
        if (res && this.getFlowId()) {
          this.stepsState = res?.steps_state;
          // this.updateStepState(res?.steps_state);
        }
        const viewModeVal = [...Status.VIEW_MODE, Status.FlowEnum.Rejected];
        this.viewMode = viewModeVal.includes(res?.status);
        this.isFlowChanged = false; // Reset isFlowChanged to re-detect change DOM
      })
    );
  }

  flowChanged(value: any, action, stepNum, valueChanged = true, stepId?): void {

    if (action === 'prev') {
      if (this.viewMode || !valueChanged) {
        this.previousNavigate(stepNum);
        return;
      }
      const config = Constants.getConfirmConfig(
        this.translateService.translate('Changes done to this step will not be SAVED, Do you want to proceed?'),
        'yes',
        'no'
      );
      SwalService.customSwal(config, Constants.AlertCommonStyle, async (result) => {
        if (result.value) { this.previousNavigate(stepNum); }
      });
    } else {
      this.onSave(value, stepNum, stepId).subscribe(() => {
        this.goNext(stepNum, action)
      }, (err) => {
        SwalService.warning(err.message);
      });
    }
  }

  goNext(stepNum, action) {
    if([3, 4, 5].includes(stepNum)) {
      stepNum = 3
    }
    if(stepNum === 6) {
      stepNum = 4
    }
    this.selectedIndex = stepNum + (action === 'next' ? 0 : -2);
    this.isFlowChanged = true;
    this.router.navigate([
      DashboardConstants.endpoint[ this.getCurrentMode()] + (stepNum + (action === 'next' ? 1 : -1)),
    ],  { queryParams: { id: this.getFlowId() }
  })
  }

  previousNavigate(stepNumber): void {
    this.selectedIndex = stepNumber - 2;
    this.isFlowChanged = true;
    this.router.navigate([
      DashboardConstants.endpoint[this.getCurrentMode()] + (stepNumber - 1),
    ], { queryParams: { id: this.getFlowId() }});
  }

  onSave(body, stepNum, stepId?): Observable<any> {
    if (this.viewMode || isEmpty(body)) {
      return of(null);
    }
    switch (stepNum) {
      case 1:
        return this.flowService.upsertFlowInfo(body[0], this.url).pipe(
          map((res) => {
            this.flowId = res?.id;
            sessionStorage.setItem('flowId', res?.id);
          })
        );
      case 2:
          return this.flowService.updateFlowPersona(
            this.getFlowId(),
            { ref_personas: body },
            this.url
          );

      case 3:
          return this.flowService.upsertJourneyPoint(
            { steps: body },
            this.getFlowId(),
            this.url
          );

      case 4:
          return this.flowService.updateFlowGroup(this.getFlowId(), { groups: body }, this.url);
      default:
        break;
    }
  }

  getCurrentMode(): string {
      return 'flow';
  }

  getFlowId(): number {
    return this.flowId ? this.flowId : this.activatedRoute.snapshot.queryParams?.id;
  }

  getSelectedIndex(): number {
    const stepIndex = window.location.pathname.split('step');
    return stepIndex.length ? Number(stepIndex[1]) - 1 : 0;
  }

  fireErrorMsg(msg, action): void {
    if (action === 'next') {
      SwalService.error(msg);
    }
  }

  upsertJourneyPoint(body) {
    return this.flowService.upsertJourneyPoint(
      {steps: body},
      this.getFlowId(),
      this.url
    )
  }

  updateJourneyGroups(body) {
    return this.flowService.updateFlowGroup(
      this.getFlowId(),
      body,
      this.url
    )
  }

  //Update expectedDate, actions, refDocument
  updateJourneyOther(body, stepId) {
    return this.flowService.upsertActions(
      this.getFlowId(),
      body,
      stepId,
      this.url
    )
  }


  isHelpValidate(): boolean {
    if(this.helpFlowPersonaIdValidate) {
      return true
    }
    return false
  }

  setHelpValidate(flowPersonaId: number, company?: any): void {
    this.helpFlowPersonaIdValidate = flowPersonaId
    if(company) {
      this.helpFlowCompanyValidate = company;
    }
  }

  getHelpValidate(): number {
    return this.helpFlowPersonaIdValidate
  }

  getHelpValidateCompany() {
    return this.helpFlowCompanyValidate
  }

  removeHelpValidate(removeCompany = false): void {
    this.helpFlowPersonaIdValidate = null;
    if(removeCompany) {
      this.helpFlowCompanyValidate = null
    }
  }
}
